module.exports = __webpack_public_path__ + "media/images/lp/plight5-sp-936bf8994cf1e9f845549070a62320a0.png";